var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsAppIcon = function SvgWhatsAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.59 4.806C16.836 2.996 14.506 2 12.027 2s-4.808.997-6.56 2.806c-1.754 1.81-2.719 4.216-2.719 6.775 0 1.62.398 3.214 1.152 4.625L1.937 22l5.612-2.028a9.05 9.05 0 0 0 4.48 1.19c2.478 0 4.808-.997 6.56-2.807 1.753-1.81 2.718-4.215 2.718-6.774s-.965-4.965-2.718-6.775M16.614 15.14l-1.07 1.106c-.888.916-3.406-.198-5.625-2.489S6.623 8.867 7.51 7.95l1.071-1.106a.556.556 0 0 1 .804 0l1.339 1.383a.6.6 0 0 1 0 .83l-.804.829a8 8 0 0 0 3.75 3.871l.803-.83a.555.555 0 0 1 .803 0l1.34 1.383a.6.6 0 0 1 0 .83"
  })));
};
export default SvgWhatsAppIcon;